export { default as default } from '../modules/react/Input'


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/input-format/react/index.js
// module id = 1687
// module chunks = 6 14 79